import React from 'react';

import cx from 'classnames';
import { Icon, Tooltip } from 'design-system-web';
import { ValidatedInput } from 'components';

import { S } from 'components/typography';

import styles from './VisitorInput.scss';

type Props = {
  className?: string;
  style?: React.CSSProperties;
  displayName: string;
  value: number | string | null | undefined;
  placeholder: string;
  type?: 'number' | 'text' | 'email' | 'password' | 'tel' | undefined;
  onChange: (value: string) => void;
  onBlur?: (value: string) => void;
  validation?: {};
  isPristine?: boolean;
  isHidden?: boolean;
  isRequired?: boolean;
  testId?: string;
  isDisabled?: boolean;
  tooltipText?: string;
};

export default function VisitorInput({
  className,
  style,
  displayName,
  value,
  placeholder,
  type = 'text',
  onChange,
  onBlur,
  validation,
  isPristine,
  isHidden = false,
  isRequired = false,
  testId,
  isDisabled = false,
  tooltipText,
}: Props) {
  if (isHidden) return null;

  return (
    <div className={cx(styles.visitorInput, className)} style={style}>
      <div className={styles.labelRow}>
        <S>
          {displayName}
          {isRequired ? <span className={styles.required}>*</span> : ''}
        </S>
        {tooltipText ? (
          <Tooltip
            TooltipComponent={tooltipText}
            placement="bottom-start"
            zIndex={6}
            className={styles.tooltip}
          >
            <Icon
              name="info-circle"
              set="FontAwesome"
              type="far"
              className={styles.infoIcon}
              size="small"
            />
          </Tooltip>
        ) : null}
      </div>
      <ValidatedInput
        testId={testId}
        className={styles.inputField}
        value={value}
        placeholder={placeholder}
        type={type}
        onChange={onChange}
        onBlur={onBlur ? value => onBlur(String(value)) : undefined}
        validation={validation}
        isPristine={isPristine}
        disabled={isDisabled}
      />
    </div>
  );
}
